import React, {Component, Fragment} from 'react';
import Switch from '@material-ui/core/Switch';
import CircularProgress from '@material-ui/core/CircularProgress'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


import {Navigationmenu} from '../components';
import {
    Box,
    Button,
    Typography,
    Grid,
    Divider,
    MuiEditableLabel,
    TextField,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    FormControl,
    Select,
    InputLabel,
    MenuItem,
    Popover,
    Dialog,
    Checkbox,
    Tabs,
    Tab,
    DialogActions,
    withStyles,
    TableFooter
} from '@material-ui/core';
import {
    SearchOutlined,
    ArrowDropDown,
    Publish,
    NoteAdd,
    ArrowDropUp,
    InsertDriveFileOutlined,
    AlternateEmail
} from '@material-ui/icons';
import {
    ALTERNATEROW_BACKGROUND_COLOR,
    BLUE_COLOR, LIGHTGRAY_COLOR,
    MODIFIEDBLACK,
    PINK_COLOR,
    PROTECT_GREEN,
    RED_COLOR,
    VIBRANT_GREEN
} from "../constants";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import List from "@material-ui/core/List";
import renderIf from 'render-if';
import {Redirect} from "react-router-dom";
import axios from "axios"
import {fnPostapiResponse,fnGETapiResponse} from '../APICall';


const StyledTabs = withStyles({
    indicator: {
        display: 'flex',
        backgroundColor: 'white',
        height:3
    },
},{index:1})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        color: 'white',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        '&:focus': {
            opacity: 1
        }
    },
},{index:1}))((props) => <Tab disableRipple {...props} />);

export default class Commonmail extends Component {
    state={
        tablebuffer:[],
        pages:0,
        current:1,
        records:0,
        pageSize:10,
        showPager:false,
        SOURCE:"",
        FNAME:"",
        SNAME:"",
        pagesObj:[],
        CMLNIC:"",
        SelectedCompany:"SWAN GENERAL",
        CMLSURNAME:"",
        CMLFORENAME:"",
        CMLEMAIL:"",
        CMLSELECTEDATE:"",
        CMLSGCHECKED:false,
        CMLSSLCHECKED:false,
        CMLSPLCHECKED:false,
        CMLSSCCHECKED:false,
        CMLSWLCHECKED:false,
        CMLMOBILE:"",
        CMLTELHOME:"",
        CMLOFFICE:"",
        CMLCLIENT:"",
        CMLISLODING:false,CMLDDLCHANNEL:"",CMLDDLMODE:""
    }
    
    handleCancelClick()
    {
      var r = window.confirm("Do you really want Clear ?")
      if(r == true)
      window.location.reload();
    }
    handeltextChange(e,key){
      this.setState({key:e.target.value});
      this.state[key] = e.target.value;
    }
    componentDidMount()
    {
      var date = new Date()
      var month = date.getMonth() + 1<10?"0" +( date.getMonth()+ 1) : date.getMonth()+1
      var date1 = date.getDate() <10?"0" +( date.getDate()) : date.getDate()
      var CMLSELECTEDATE = date.getFullYear() +"-"+ month +"-"+ date1
      this.setState({CMLSELECTEDATE :CMLSELECTEDATE })
    }
    fetchDetails(rowObj)
    {
      this.setState({
        CMLNIC :rowObj['NIC'],
        CMLCLIENT: rowObj['CLIENTID'],
        SelectedCompany: rowObj['COMPANY'],
        // CMLSURNAME: rowObj['FULLNAMES'],
        CMLEMAIL: rowObj['EMAIL1'],
        CMLMOBILE: rowObj['TELEPHONE_MOBILE']

     })
    // POST request using fetch with error handling
    var data = {
          "MAPIURL":""+process.env.REACT_APP_SOURCE_URL+"",
          "MAPINAME":'GetValue',
          "MAPIPORT":process.env.REACT_APP_MPORT,
          "body": {  
            
                  "clientid":rowObj['CLIENTID']||"",
                  "companyName":rowObj['COMPANY']||""
          }
        }
          console.log(data)
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,'PostApiMiddleWare',data,process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {   
          this.setState({
            CMLFORENAME:response.data[0][0]['FORENAMES'],
            CMLSURNAME:response.data[0][0]['SURNAME']
        }); }).catch(e => console.log(e));
    }

    
    renderpages(){
      this.state.records = this.state.alldata.length;
      this.state.pages = parseInt( this.state.records / this.state.pageSize)
      if(this.state.records % this.state.pageSize >0)
          this.state.pages++;
       this.state.showPager=this.state.pages>1
      this.pageChange(0)
  }
    Searchdatavalue()
    {
      this.setState({alldata:[],pagesObj:[]})

      var data = 
      {
        "MAPIURL":""+process.env.REACT_APP_SOURCE_URL+"",
        "MAPINAME":'PostSearch',
        "MAPIPORT":process.env.REACT_APP_MPORT,
        "body": {  
            // "Nic":"H040774301593E"
             "Nic": ""+this.state.CMLNIC+"" || "",
            "SurnameVal": this.state.CMLSURNAME.toUpperCase() || "",
            "forNameval": this.state.CMLFORENAME || "",
            "MobileNumber": this.state.CMLMOBILE || "",
            "HomeNumber":this.state.CMLTELHOME||"",
            "officeNumber":this.state.CMLOFFICE||"",
            "ClientId":this.state.CMLCLIENT||""
          }}

        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,'PostApiMiddleWare',data,process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {   
         console.log(data)

          if(response.data.SearchValue==undefined)
          {
              alert(response.data.Message)
              this.ClearGrid()
          }
          else{
              if(response.data.SearchValue[0].length==0){
              alert("No data found!")
              this.ClearGrid()
            }
              else{
                if(response.data.SearchValue[0].length > 10){
                var result = window.confirm("Do you want to see all records ? (If NO please enter Search Criteria.)")
                if(result){
              this.setState({
              CMLISLODING:false,
              alldata:response.data.SearchValue[0]})
              this.renderpages()
              this.setState({
                CMLISLODING:false})
            }
              
              else
              {
                this.ClearGrid()
              }
            }
              else
              {
                this.setState({
                  CMLISLODING:false,
                  alldata:response.data.SearchValue[0]})
                  this.renderpages()}
              }
          }}).catch(e => console.log(e));  
    }
    ClearGrid(){this.setState({alldata:[],
      CMLISLODING:false,pagesObj:[]
      })
this.renderpages()}
    pageChange(number){
      this.state.current=number;
      var data = this.state.alldata.slice(this.state.current*this.state.pageSize,(this.state.current+1)*this.state.pageSize);
      this.setState({tablebuffer:data})
      
      this.state.pagesObj=[];
      if(this.state.pages < 10){
          for(var i = 0;i<this.state.pages;i++)
              this.state.pagesObj.push(i);
      }
      else
          {
              var min = this.state.current-5;
              var max = this.state.current+5;
              if(min<0)
                  min=0;
              if(max>this.state.pages)
                  max=this.state.pages;
              if(max-min>10)
              {
                  min = this.state.current-5;
                  max = this.state.current+5;
              }
              if(min>0)
                  this.state.pagesObj.push(0);
              for(var i =min;i<max;i++)
                  this.state.pagesObj.push(i);
              if(max<this.state.pages-1)
                  this.state.pagesObj.push(this.state.pages-1);

          }
  }
  isEven(n) {
    return n % 2 == 0;
}

    Nicchecking(){
      if(this.state.CMLNIC.trim()=="")
      {
        this.Searchdatavalue()
      }
      else{

      var data =
      {
        "MAPIURL":""+process.env.REACT_APP_SOURCE_URL+"",
            "MAPINAME":'ValidateNIC',
            "MAPIPORT":''+process.env.REACT_APP_MPORT1+'',
            "body":{
        "strFirstCharToCheck": "",
        "strSurname": "",
        "strMaiden": "",
        "strSex": "",
        "strDOB": "",
        "strCountryCode": "",
        "strNic": this.state.CMLNIC.trim(),
        "strStatus": "",
        "strMessage": "",
        "blCheckDigitOnly": true
       }
      }
      fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,'PostApiMiddleWare',data,process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {   
      
      
        this.state.nivvaliderror = response.data
         if(this.state.nivvaliderror==true)
      {
        this.Searchdatavalue()
      }
      else
      {
        alert(this.state.nivvaliderror)
      }
    }).catch(e => console.log(e));
    }
   }
   handleSomeDateChange(e){
     this.setState({CMLSELECTEDATE:e.target.value})
   }
  

    handleSearchClick(e) {
      this.Nicchecking()
    }
    handlesaveClick()
    {
      if((this.state.CMLDDLCHANNEL==""||this.state.CMLDDLMODE=="" || this.state.CMLSELECTEDATE=="") || ( !this.state.CMLSSLCHECKED&&!this.state.CMLSGCHECKED&&!this.state.CMLSPLCHECKED 
    &&!this.state.CMLSSCCHECKED&&!this.state.CMLSWLCHECKED))
      {
        alert("Record cannot be saved ! Please fill all mandatory fields Denoted by * ")
      }
      else{
        var datenew = this.state.CMLSELECTEDATE
      //   var month = date.getMonth() + 1<10?"0" +( date.getMonth()+ 1) : date.getMonth()+1
      // var date1 = date.getDate() <10?"0" +( date.getDate()) : date.getDate()
      //   var datenew = date1 + month + date.getFullYear() 
        
      var SgVal= this.state.CMLSGCHECKED?"Y":"N"
      var SllVal= this.state.CMLSSLCHECKED?"Y":"N"
      var SplVal= this.state.CMLSPLCHECKED?"Y":"N"
      var SscVal= this.state.CMLSSCCHECKED?"Y":"N"
      var SwlVal= this.state.CMLSWLCHECKED?"Y":"N"
       // POST request using fetch with error handling
       var data =
        {
          "MAPIURL":""+process.env.REACT_APP_SOURCE_URL+"",
          "MAPINAME":'POSTSave',
          "MAPIPORT":process.env.REACT_APP_MPORT,
          "body": {  
            "Nicval":""+this.state.CMLNIC+"",
            "Surname":""+this.state.CMLSURNAME+"",
            "Forname":""+this.state.CMLFORENAME+"",
            "Email":""+this.state.CMLEMAIL+"",
            "ClientidVal":""+this.state.CMLCLIENT+"",
            "MObileno":""+this.state.CMLMOBILE+"",
            "Homeno1":""+this.state.CMLOFFICE+"",
            "Homeno2":""+this.state.CMLTELHOME+"",
            "mode":""+this.state.CMLDDLMODE+"",
            "date1":""+datenew+"",
            "Channel":""+this.state.CMLDDLCHANNEL+"",
            "SllVal":""+SllVal+"",
            "SgVal":""+SgVal+"",
            "SplVal":""+SplVal+"",
            "SscVal":""+SscVal+"",
            "SwlVal":""+SwlVal+"",
        "company":""+this.state.SelectedCompany+""
            }
    };
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,'PostApiMiddleWare',data,process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {   
          if(response.data=="Information already exist. Do you want to reinsert?")
          {
            var r = window.confirm("Information already exist. Do you want to reinsert?")
            if(r){
              var datare =
              {
                "MAPIURL":""+process.env.REACT_APP_SOURCE_URL+"",
                "MAPINAME":'POSTReInsertSave',
                "MAPIPORT":process.env.REACT_APP_MPORT,
                "body": {  
                  "Nicval":""+this.state.CMLNIC+"",
                  "Surname":""+this.state.CMLSURNAME+"",
                  "Forname":""+this.state.CMLFORENAME+"",
                  "Email":""+this.state.CMLEMAIL+"",
                  "ClientidVal":""+this.state.CMLCLIENT+"",
                  "MObileno":""+this.state.CMLMOBILE+"",
                  "Homeno1":""+this.state.CMLOFFICE+"",
                  "Homeno2":""+this.state.CMLTELHOME+"",
                  "mode":""+this.state.CMLDDLMODE+"",
                  "date1":""+datenew+"",
                  "Channel":""+this.state.CMLDDLCHANNEL+"",
                  "SllVal":""+SllVal+"",
                  "SgVal":""+SgVal+"",
                  "SplVal":""+SplVal+"",
                  "SscVal":""+SscVal+"",
                  "SwlVal":""+SwlVal+"",
                  "company":""+this.state.SelectedCompany+""
                  }
          };
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE,'PostApiMiddleWare',data,process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {   
          const data1 = response.data
            alert(data1)
           }).catch(e => console.log(e));
          }
            
          }else{
          alert(response.data)}
         }).catch(e => console.log(e));
  }
    }
    render() {
     
        return (
            <Fragment>
                <Navigationmenu selectedMenu={'CML'}/>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{marginTop: 35}}
                >
                    <Paper elevation={2} style={{minHeight: 100, width: '90%', borderRadius: 6}}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <div style={{minHeight: 100, width: '98%', borderRadius: 6}}>

                                <Grid container spacing={2}>
                                    <Grid item xs={11}>
                                        <div style={{
                                            display:'flex',
                                            marginBottom:20,
                                            marginTop:60
                                        }}>
                                            <Typography style={{borderWidth:0,color:BLUE_COLOR,textTransform:'uppercase',fontFamily:'Globerbold',fontSize:30,paddingLeft:10}}>IN SCREEN</Typography>
                                        </div>
                                    </Grid>
                                </Grid>

                                {/*FILTER DROPDOWNS*/}
                                <Grid container spacing={2}>
                                <Grid item xs = {4}>
                <TextField fullWidth label="NIC" 
                value ={this.state.CMLNIC} 
                onChange={(e)=>this.handeltextChange(e,"CMLNIC")} variant="outlined" 
                width='10px' />
              </Grid>
              <Grid item xs={1} >
               Company
                </Grid>
              <Grid item xs ={3}>

              <Select fullWidth 
                        variant={'outlined'}
                        value={this.state.SelectedCompany}
                        onChange={e=>this.setState({SelectedCompany:e.target.value})}
                      >
               <MenuItem value="SWAN GENERAL">SWAN GENERAL</MenuItem>
               <MenuItem value="SWAN LIFE">SWAN LIFE</MenuItem>
               <MenuItem value="SWAN PENSIONS">SWAN PENSIONS</MenuItem>
               <MenuItem value="SWAN SECURITIES">SWAN SECURITIES</MenuItem>
               <MenuItem value="SWAN WEALTH">SWAN WEALTH</MenuItem>
                 </Select>
              </Grid>
              <Grid item xs = {4}>
                <TextField fullWidth label="SURNAME" value={this.state.CMLSURNAME} variant="outlined" inputProps={{style: {textTransform: 'uppercase'}}} onChange={(e)=>this.handeltextChange(e,"CMLSURNAME")}  />
              </Grid>
            
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs>
                <TextField fullWidth label="FORENAMES" value={this.state.CMLFORENAME} onChange={(e)=>this.handeltextChange(e,"CMLFORENAME")}  variant="outlined" />
              </Grid>
              <Grid item xs>
                <TextField fullWidth label="EMAIL" value={this.state.CMLEMAIL} variant="outlined" onChange={(e)=>this.handeltextChange(e,"CMLEMAIL")}  />
              </Grid>
              <Grid item xs>
                <TextField fullWidth label="CLIENTID" value={this.state.CMLCLIENT} onChange={(e)=>this.handeltextChange(e,"CMLCLIENT")}  variant="outlined" />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs>
                <TextField fullWidth label="TELMOBILE" value={this.state.CMLMOBILE} variant="outlined" onChange={(e)=>this.handeltextChange(e,"CMLMOBILE")}  />
              </Grid>
              <Grid item xs>
                <TextField fullWidth label="TELHOME" value={this.state.CMLTELHOME} onChange={(e)=>this.handeltextChange(e,"CMLTELHOME")}  variant="outlined" />
              </Grid>
               <Grid item xs>
                <TextField fullWidth label="TELOFFICE" value={this.state.CMLOFFICE} variant="outlined" onChange={(e)=>this.handeltextChange(e,"CMLOFFICE")}  />
              </Grid>
            </Grid>
            
            <Grid container spacing={2}>
              <Grid item xs={1}>
                MODE 
                <label style={{color:RED_COLOR,textTransform:'uppercase', marginLeft:7}}>*</label>
              </Grid>
              <Grid item xs ={3} >
                  <Select fullWidth 
                            variant={'outlined'}
                            value={this.state.CMLDDLMODE}
                            onChange={e=>this.setState({CMLDDLMODE:e.target.value})}
                          >
                  <MenuItem value=""></MenuItem>
                  <MenuItem value="OptOUt">OPT OUT</MenuItem>
                  </Select>
              </Grid>
              <Grid item xs={4}>
              <TextField  id="date" label="DATE" variant={'outlined'} value={this.state.CMLSELECTEDATE} type="date" InputLabelProps={{ shrink: true,}}
               onChange={e=>this.handleSomeDateChange(e)}
                />  
                
                <lable style={{color:RED_COLOR,textTransform:'uppercase',marginLeft:7}}>*</lable>
                </Grid>
              
              
              {/* <DatePicker fullWidth 
               className="Input"
               dateFormat="dd/MM/yyyy" 
                        variant={'outlined'} selected={this.state.CMLSELECTEDATE} onChange={date => this.setStartDate(date)} />
               */}
              <Grid item xs >
                CHANNEL 
              
                <label style={{color:RED_COLOR,textTransform:'uppercase',marginLeft:7}}>*</label>
                </Grid>
              <Grid item xs={3}>
              <Select fullWidth 
                          variant={'outlined'}
                          value={this.state.CMLDDLCHANNEL}
                          onChange={e=>this.setState({CMLDDLCHANNEL:e.target.value})}
                        >
                <MenuItem value=""></MenuItem>
                <MenuItem value="Email">EMAIL </MenuItem>
                <MenuItem value="Walking">WALKING </MenuItem>
                <MenuItem value="Letter">LETTER </MenuItem>
                  </Select>
              </Grid>
             
            </Grid>
             
            <Grid container spacing={2}>
            <Grid item xs ={1}>
                                        <Checkbox name="chkdoNotShare" color="primary" checked={this.state.CMLSGCHECKED} onChange={e=>this.setState({CMLSGCHECKED:e.target.checked})}/>
                                        SG
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Checkbox name="chkAgent" color="primary" checked={this.state.CMLSSLCHECKED} onChange={e=>this.setState({CMLSSLCHECKED:e.target.checked})}/>
                                        SLL
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Checkbox name="chkswancompany" color="primary" checked={this.state.CMLSPLCHECKED} onChange={e=>this.setState({CMLSPLCHECKED:e.target.checked})}/>
                                        SPL
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Checkbox name="chkUndeliverd" color="primary" value={this.state.CMLSSCCHECKED}onChange={e=>this.setState({CMLSSCCHECKED:e.target.checked})}/>
                                        SSL </Grid>
                                    <Grid item xs={1}>
                                        <Checkbox name="chkUndeliverd" color="primary" value={this.state.CMLSWLCHECKED}onChange={e=>this.setState({CMLSWLCHECKED:e.target.checked})}/>
                                        SWL
                                    </Grid>
                                    <Grid>
                </Grid>
                <lable style={{color:RED_COLOR,textTransform:'uppercase',marginTop:10}}>*</lable>

                                    <Grid item xs={2}>
</Grid>
                                    <Grid item xs>
              <Button variant={'text'}  onClick={(e)=>this.handleSearchClick(e)} style={{color:'white',fontFamily:'Globerbold',backgroundColor:BLUE_COLOR,width:'121px',height:'40px'}}>
                                                                Search
                                                    </Button>
                                                    &nbsp;&nbsp;
              <Button variant={'text'} onClick={(e)=>this.handlesaveClick(e)} style={{color:'white',fontFamily:'Globerbold',backgroundColor:BLUE_COLOR,width:'121px',height:'40px'}}>
                                                                Save
                                                    </Button>
                                                    &nbsp;&nbsp;
                <Button variant={'text'}  onClick={(e)=>this.handleCancelClick(e)} style={{color:'white',fontFamily:'Globerbold',backgroundColor:BLUE_COLOR,width:'121px',height:'40px'}}>
                                                                Clear
                                                    </Button>
              </Grid>
            </Grid>
            
            <Divider style={{marginTop:15}}/>
            <Grid container spacing={2} style={{marginTop:10}}>
            <TableContainer>
                            <Table aria-label="simple table">
                                <TableHead style={{backgroundColor:'rgba(241,241,241,1.0)'}}>
                                    <TableRow>
                                        <TableCell style={{borderWidth:0,color:MODIFIEDBLACK,textTransform:'uppercase',fontFamily:'Globerbold'}} align="center">Company</TableCell>
                                        <TableCell style={{borderWidth:0,color:MODIFIEDBLACK,textTransform:'uppercase',fontFamily:'Globerbold'}} align="center">CLIENTID</TableCell>
                                        <TableCell style={{borderWidth:0,color:MODIFIEDBLACK,textTransform:'uppercase',fontFamily:'Globerbold'}} align="center">NIC</TableCell>
                                        <TableCell style={{borderWidth:0,color:MODIFIEDBLACK,textTransform:'uppercase',fontFamily:'Globerbold'}} align="center">FULLNAMES</TableCell>
                                        <TableCell style={{borderWidth:0,color:MODIFIEDBLACK,textTransform:'uppercase',fontFamily:'Globerbold'}} align="center">MOBILE</TableCell>
                                        <TableCell style={{borderWidth:0,color:MODIFIEDBLACK,textTransform:'uppercase',fontFamily:'Globerbold'}} align="center">EMAIL</TableCell>
                                        <TableCell style={{borderWidth:0,color:MODIFIEDBLACK,textTransform:'uppercase',fontFamily:'Globerbold'}} align="center">TYPE OF LETTER</TableCell>
                                        <TableCell style={{borderWidth:0,color:MODIFIEDBLACK,textTransform:'uppercase',fontFamily:'Globerbold'}} align="center">SEND BY</TableCell>
                                        <TableCell style={{borderWidth:0,color:MODIFIEDBLACK,textTransform:'uppercase',fontFamily:'Globerbold'}} align="center">DATE SENT</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {!this.state.CMLISLODING ?
                                            this.state.tablebuffer.map((obj,index)=>{

                                            var rowbackgroundColor = 'white';
                                            if(this.isEven(index)){rowbackgroundColor = ALTERNATEROW_BACKGROUND_COLOR;}

                                            if(this.state.ishovered && this.state.hoverindex==index){rowbackgroundColor=LIGHTGRAY_COLOR}
                                            return(

                                                <TableRow style={{cursor:'pointer'}} onClick={(e)=>this.fetchDetails(obj)} key={index}>
                                                    <TableCell  style={{borderWidth:0,whiteSpace: 'unset', color:MODIFIEDBLACK,textTransform:'uppercase',fontFamily:'Globerbold',backgroundColor:rowbackgroundColor}} align="center">{obj.COMPANY}</TableCell>
                                                    <TableCell style={{borderWidth:0,whiteSpace: 'unset', color:BLUE_COLOR,textTransform:'uppercase',fontFamily:'Globerbold',backgroundColor:rowbackgroundColor}} align="center">{obj.CLIENTID}</TableCell>
                                                    <TableCell style={{borderWidth:0,whiteSpace: 'unset', color:BLUE_COLOR,textTransform:'uppercase',fontFamily:'Globerbold',backgroundColor:rowbackgroundColor}} align="center">{obj.NIC}</TableCell>
                                                    <TableCell style={{borderWidth:0,whiteSpace: 'unset', color:BLUE_COLOR,textTransform:'uppercase',fontFamily:'Globerbold',backgroundColor:rowbackgroundColor}} align="center">{obj.FULLNAMES}</TableCell>
                                                    <TableCell style={{borderWidth:0,whiteSpace: 'unset',color:BLUE_COLOR,textTransform:'uppercase',fontFamily:'Globerbold',backgroundColor:rowbackgroundColor}} align="center">{obj.TELEPHONE_MOBILE}</TableCell>
                                                    <TableCell style={{borderWidth:0,whiteSpace: 'unset', color:BLUE_COLOR,textTransform:'uppercase',fontFamily:'Globerbold',backgroundColor:rowbackgroundColor}} align="center">{obj.EMAIL1}</TableCell>
                                                    <TableCell style={{borderWidth:0,whiteSpace: 'unset', color:BLUE_COLOR,textTransform:'uppercase',fontFamily:'Globerbold',backgroundColor:rowbackgroundColor}} align="center">{obj.CLIENT_NOTIFICATION_DOC}</TableCell>
                                                    <TableCell style={{borderWidth:0,whiteSpace: 'unset', color:BLUE_COLOR,textTransform:'uppercase',fontFamily:'Globerbold',backgroundColor:rowbackgroundColor}} align="center">{obj.CLIENT_NOTIFICATION_CHANNEL}</TableCell>
                                                    <TableCell style={{borderWidth:0,whiteSpace: 'unset', color:BLUE_COLOR,textTransform:'uppercase',fontFamily:'Globerbold',backgroundColor:rowbackgroundColor}} align="center">{obj.CLIENT_NOTIFICATION_DATE}</TableCell>
                                                </TableRow>
                                            )
                                        })
                                    : <td colspan="9" align="center"> Loading.... <CircularProgress classes="CircularProgress" /></td>}
                                </TableBody>
                            </Table>
                            <div >
                                {
                                        this.state.pagesObj.map((obj,index)=>{
                                            return(
                                                <span style={{padding:"0 3px",cursor:"pointer"}}> 
                                                    <a  style={this.setState.current==obj ? { fontWeight: 'bold' }:{}} onClick={()=>this.pageChange( obj)} >{obj+1}</a>  
                                                </span>
                                            )
                                        })
                                    }
                                </div>
                        </TableContainer>
                        <Divider></Divider>
                       
            </Grid> 
              <Divider style={{marginTop:15}}/>

            <Grid container spacing={2} style={{marginTop:10}}>
            <Grid item xs></Grid>
            <Grid item xs></Grid>
            
             </Grid>
             <Grid container spacing={2} style={{marginTop:20}}></Grid>
                            </div>
                        </Box>
                    </Paper>
                </Box>
            </Fragment>
        )
    }
}